(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-motiv-check"] && !Shopify.designMode) return;
  try {
    function fsAssessResolution(width, height, title) {
    const matches = [...String(title).matchAll(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm\b/gi)];
    if (matches.length !== 1 || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
    const cmWidth = Number(matches[0][1].replace(',', '.'));
    const cmHeight = Number(matches[0][2].replace(',', '.'));
    if (cmWidth <= 0 || cmHeight <= 0) return null;
    const ppi = Math.min(width * 2.54 / cmWidth, height * 2.54 / cmHeight);
    return { width, height, cmWidth, cmHeight, ppi, enough: ppi >= 150,
      ratioMismatch: Math.abs((width / height) / (cmWidth / cmHeight) - 1) > 0.05,
      requiredWidth: Math.ceil(cmWidth / 2.54 * 150), requiredHeight: Math.ceil(cmHeight / 2.54 * 150) };
  }

  if (!customElements.get('fs-motiv-check')) {
    customElements.define('fs-motiv-check', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.sequence = (this.sequence || 0) + 1;
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.templates = JSON.parse(this.querySelector('[data-template-map]').textContent)[this.dataset.handle] || [];
        this.templateLink = this.querySelector('[data-template-link]');
        this.allTemplatesHref = this.templateLink.getAttribute('href');
        this.updateTemplateLink(this.variants[this.dataset.variantId]);
        this.input = this.querySelector('input[type="file"]');
        this.result = this.querySelector('[role="status"]');
        this.orderCheck = this.querySelector('[data-order-check]');
        this.assistance = this.querySelector('[data-assistance]');
        this.helpRequest = this.querySelector('[data-help-request]');
        this.helpNotes = this.querySelector('[data-help-notes]');
        this.helpDetails = this.querySelector('[data-help-details]');
        this.replaceHint = this.querySelector('[data-replace-hint]');
        const opts = { signal: this.controller.signal };
        this.input.addEventListener('change', () => { this.activeSource = 'local'; this.orderCheck.disabled = true; this.uploadFetch?.abort(); this.readFile(); }, opts);
        this.parentSection = document.getElementById('shopify-section-' + this.dataset.sectionId);
        this.helpRequest.addEventListener('change', () => this.syncAssistance(), opts);
        this.querySelector('[data-replace-upload]').addEventListener('click', () => {
          const button = this.parentSection?.querySelector('[data-ph-fieldname="Produktupload"] .uploadcare--widget_status_loaded .uploadcare--widget__file-name') || this.parentSection?.querySelector('[data-ph-fieldname="Produktupload"] .uploadcare--widget__button_type_open');
          this.replaceHint.hidden = Boolean(button);
          if (button) { button.focus(); button.click(); }
        }, opts);
        this.parentSection?.addEventListener('variant:change', (event) => {
          if (event.detail?.variant?.id) this.dataset.variantId = String(event.detail.variant.id);
          this.updateTemplateLink(this.variants[this.dataset.variantId]);
          this.resetAfterVariantChange();
        }, opts);
        this.parentSection?.addEventListener('change', (event) => {
          if (event.target === this.input) return;
          if (event.target?.name === 'id' && this.variants[event.target.value]) this.dataset.variantId = event.target.value;
          if (event.target?.matches('select, input[type="radio"], input[name="id"]')) this.resetAfterVariantChange();
        }, opts);
        const removeSelection = event => {
          const button = event.target.closest('[data-fs-remove]');
          if (!button || (event.type === 'keydown' && !['Enter', ' '].includes(event.key))) return;
          const preview = button.closest('[id^="previewImages_"]');
          const fieldId = preview?.id.slice('previewImages_'.length);
          const config = window.UPLOADCARE_DATA?.[fieldId];
          if (!config?.widget || preview.children.length !== 1) return;
          event.preventDefault(); event.stopImmediatePropagation();
          config.widget.value(null);
          document.querySelectorAll('[data-img-id][id*="imageFiles_' + fieldId + '"]').forEach(element => element.remove());
          preview.replaceChildren();
          preview.style.marginBottom = '0';
          const uploadButton = document.getElementById('selBtn_' + fieldId)?.querySelector('.uploadcare--widget__button_type_open');
          if (uploadButton) uploadButton.textContent = config.uploadButtonText || this.messages.choose;
          this.scanUploadedFile(true);
        };
        this.parentSection?.addEventListener('click', removeSelection, { ...opts, capture: true });
        this.parentSection?.addEventListener('keydown', removeSelection, { ...opts, capture: true });
        this.uploadObserver?.disconnect();
        if (this.parentSection) {
          this.uploadObserver = new MutationObserver(() => {
            clearTimeout(this.uploadScanTimer);
            this.uploadScanTimer = setTimeout(() => this.scanUploadedFile(), 100);
          });
          this.uploadObserver.observe(this.parentSection, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cdn', 'value'] });
          this.scanUploadedFile();
        }
      }

      async scanUploadedFile(force = false) {
        this.parentSection.querySelectorAll('[id^="previewImages_"] [title^="Remove "]:not([data-fs-remove])').forEach(button => {
          button.dataset.fsRemove = 'true';
          button.textContent = this.messages.remove;
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
          button.setAttribute('aria-label', this.messages.remove);
        });
        const urls = [...new Set([...this.parentSection.querySelectorAll('input[name="properties[Produktupload]"][data-cdn]')].map(input => input.value ? input.getAttribute('data-cdn') : '').filter(Boolean))];
        const url = urls.length === 1 ? urls[0] : '';
        if (url === (this.lastUploadURL || '') && !force) return;
        if (url !== (this.lastUploadURL || '')) {
          this.helpRequest.checked = false;
          this.helpNotes.value = '';
          this.replaceHint.hidden = true;
        }
        this.lastUploadURL = url;
        this.syncAssistance();
        this.uploadFetch?.abort();
        if (!url) {
          this.cachedUpload = null;
          if (this.activeSource === 'upload') { this.sequence++; this.dimensions = null; this.say('idle', [this.messages.idle]); }
          return;
        }
        this.activeSource = 'upload';
        this.sequence++;
        this.dimensions = null;
        let parsed;
        try { parsed = new URL(url); } catch { this.say('manual', [this.messages.upload_error]); return; }
        if (parsed.protocol !== 'https:' || parsed.hostname !== '4gerljexqx.ucarecd.net') { this.say('manual', [this.messages.upload_error]); return; }
        this.input.value = '';
        this.querySelector('details').open = true;
        if (this.cachedUpload?.url === url) { this.readFile(this.cachedUpload.blob); return; }
        const sequence = ++this.sequence;
        this.dimensions = null;
        this.say('reading', [this.messages.reading]);
        const controller = new AbortController();
        this.uploadFetch = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
          if (sequence !== this.sequence || !this.isConnected) return;
          if (!response.ok) throw new Error('file unavailable');
          if (Number(response.headers.get('content-length')) > 40 * 1024 * 1024) { this.say('manual', [this.messages.large]); return; }
          if (!/^image\/(png|jpeg|webp)(?:;|$)/i.test(response.headers.get('content-type') || '')) { this.say('manual', [this.messages.upload_manual]); return; }
          const blob = await response.blob();
          if (sequence !== this.sequence || !this.isConnected) return;
          this.cachedUpload = { url, blob };
          this.readFile(blob);
        } catch {
          if (sequence === this.sequence && this.isConnected) this.say('manual', [this.messages.upload_error]);
        } finally { clearTimeout(timeout); }
      }

      updateTemplateLink(title) {
        const dimensions = fsAssessResolution(1, 1, title);
        const matches = this.templates.filter(t => dimensions && t.width === dimensions.cmWidth && t.height === dimensions.cmHeight && (t.edition === 'RECHTECK' || String(title).toUpperCase().includes(t.edition)));
        const template = matches.length === 1 ? matches[0] : null;
        this.templateLink.href = template ? template.url : this.allTemplatesHref;
        this.templateLink.textContent = template ? this.format('template', { edition: template.edition, size: template.size, width: template.width, height: template.height }) : this.messages.templates_all;
        if (template) { this.templateLink.target = '_blank'; this.templateLink.rel = 'noopener'; }
        else { this.templateLink.removeAttribute('target'); this.templateLink.removeAttribute('rel'); }
      }

      resetAfterVariantChange() {
        if (this.activeSource === 'upload' && this.lastUploadURL) { this.sequence++; this.dimensions = null; this.say('reading', [this.messages.reading]); this.scanUploadedFile(true); return; }
        if (!this.input.files?.length && !this.dimensions) return;
        this.sequence++;
        this.dimensions = null;
        this.input.value = '';
        this.say('idle', [this.messages.changed]);
      }

      disconnectedCallback() {
        this.uploadObserver?.disconnect();
        this.uploadFetch?.abort();
        clearTimeout(this.uploadScanTimer);
        this.controller?.abort();
        this.sequence++;
      }

      syncAssistance() {
        const hasUpload = this.activeSource === 'upload' && Boolean(this.lastUploadURL);
        if (!hasUpload) this.helpRequest.checked = false;
        const needsHelp = ['low', 'manual'].includes(this.result.dataset.state);
        this.helpRequest.disabled = !hasUpload;
        const requested = hasUpload && this.helpRequest.checked;
        this.assistance.hidden = !(hasUpload && (needsHelp || requested));
        this.helpDetails.hidden = !requested;
        this.helpNotes.disabled = !requested;
        if (!requested) this.helpNotes.value = '';
      }

      say(state, paragraphs) {
        this.orderCheck.disabled = !(this.activeSource === 'upload' && this.lastUploadURL);
        this.orderCheck.value = this.messages['order_' + state] || this.messages.order_manual;
        this.result.dataset.state = state;
        this.syncAssistance();
        this.result.replaceChildren(...paragraphs.map(text => {
          const p = document.createElement('p'); p.textContent = text; return p;
        }));
      }

      format(key, values) {
        return this.messages[key].replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
      }

      currentTitle() {
        const form = document.getElementById('product-form-' + this.dataset.productId + '-' + this.dataset.sectionId);
        const id = form?.elements.namedItem('id')?.value;
        return this.variants[id] || this.variants[this.dataset.variantId] || '';
      }

      showImageResult() {
        if (!this.dimensions) return;
        const assessment = fsAssessResolution(this.dimensions.width, this.dimensions.height, this.currentTitle());
        if (!assessment) { this.say('manual', [this.messages.unknown]); return; }
        const a = assessment;
        const paragraphs = [this.format('detail', { ...a, ppi: new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { maximumFractionDigits: 1 }).format(Math.floor(a.ppi * 10) / 10) }), this.messages[a.enough ? 'enough' : 'low']];
        if (a.ratioMismatch) paragraphs.push(this.messages.ratio);
        paragraphs.push(this.format('requirement', { width: a.requiredWidth, height: a.requiredHeight }));
        this.say(a.enough ? 'enough' : 'low', paragraphs);
      }

      async readFile(uploadedBlob) {
        const sequence = ++this.sequence;
        this.dimensions = null;
        const file = uploadedBlob || this.input.files?.[0];
        if (!file) { this.say('idle', [this.messages.idle]); return; }
        if (file.size > 40 * 1024 * 1024) { this.say('manual', [this.messages.large]); return; }
        let signature;
        try { signature = new Uint8Array(await file.slice(0, 12).arrayBuffer()); }
        catch {
          if (sequence === this.sequence && this.isConnected) this.say('manual', [this.messages.error]);
          return;
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        const png = [137,80,78,71,13,10,26,10].every((v,i) => signature[i] === v);
        const jpeg = signature[0] === 255 && signature[1] === 216 && signature[2] === 255;
        const webp = String.fromCharCode(...signature.slice(0,4)) === 'RIFF' && String.fromCharCode(...signature.slice(8,12)) === 'WEBP';
        if (!png && !jpeg && !webp) { this.say('manual', [this.messages.manual]); return; }
        this.say('reading', [this.messages.reading]);
        let timeout;
        try {
          const dimensions = await Promise.race([
            createImageBitmap(file).then(bitmap => {
              const result = { width: bitmap.width, height: bitmap.height }; bitmap.close(); return result;
            }),
            new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('timeout')), 10000); })
          ]);
          if (sequence !== this.sequence || !this.isConnected) return;
          this.dimensions = dimensions;
          this.showImageResult();
        } catch {
          if (sequence === this.sequence && this.isConnected) this.say('manual', [this.messages.error]);
        } finally { clearTimeout(timeout); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hiss-wunschmass-inline"] && !Shopify.designMode) return;
  try {
    (()=>{
    const money=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'});
    const areaFormat=new Intl.NumberFormat('de-DE',{maximumFractionDigits:4});
    const saved=new Map();
    const bindings=new Map();
    function init(root){
      if(root.dataset.initialized==='true')return;
      const info=root.closest('.product-info');
      const picker=info?.querySelector('variant-picker');
      const toggle=picker?.querySelector('.hiss-wunschmass__toggle');
      const sizeOption=picker?.querySelector('.hiss-wunschmass__size-option');
      const form=document.getElementById(root.dataset.formId);
      const button=form?.querySelector('button[type="submit"]');
      const headline=info?.querySelector('[data-hiss-wunschmass-headline]');
      const fields=root.querySelector('.hiss-wunschmass__fields');
      const error=root.querySelector('.hiss-wunschmass__error');
      const seamNotice=root.querySelector('.hiss-wunschmass__seam-notice');
      const isBanner=root.dataset.productHandle==='bannerfahne';
      const addons=root.querySelector('.banner-konfektion');
      const addonPrice=addons?.querySelector('.banner-konfektion__price');
      const quantity=info?.querySelector('.product-info__quantity-selector input[name="quantity"]');
      const sticky=info?.closest('.shopify-section')?.querySelector('.product-quick-add');
      if(!picker||!toggle||!sizeOption||!form||!button||!headline||!quantity)return;
      bindings.get(root.id)?.abort();
      const controller=new AbortController();
      bindings.set(root.id,controller);
      root.dataset.initialized='true';
      sizeOption.insertAdjacentElement('afterend',root);
      const previous=saved.get(root.id);
      if(previous){
        toggle.checked=previous.active;
        root.querySelector('.hiss-wunschmass__width').value=previous.w;
        root.querySelector('.hiss-wunschmass__height').value=previous.h;
        if(addons&&previous.extras){
          addons.querySelector('[data-banner-extra="ringband"]').checked=previous.extras.ringband;
          addons.querySelector('[data-banner-extra="schlaufe"]').checked=previous.extras.schlaufe;
          const savedWeight=addons.querySelector(`input[value="${previous.extras.weight}"]`);
          if(savedWeight)savedWeight.checked=true;
        }
      }
      function syncBannerExtras(){
        const ringband=addons?.querySelector('[data-banner-extra="ringband"]');
        const schlaufe=addons?.querySelector('[data-banner-extra="schlaufe"]');
        if(!ringband||!schlaufe)return;
        if(ringband.checked)schlaufe.checked=false;
        schlaufe.disabled=ringband.checked;
      }
      syncBannerExtras();
      function extras(){const ringband=!!addons?.querySelector('[data-banner-extra="ringband"]:checked');return {ringband,weight:addons?.querySelector('input[name^="banner-gewicht-"]:checked')?.value||'keine',schlaufe:!ringband&&!!addons?.querySelector('[data-banner-extra="schlaufe"]:checked')};}
      function hasExtras(){const x=extras();return x.ringband||x.weight!=='keine'||x.schlaufe;}
      function remember(){saved.set(root.id,{active:toggle.checked,w:root.querySelector('.hiss-wunschmass__width').value,h:root.querySelector('.hiss-wunschmass__height').value,extras:extras()});}
      const variants=JSON.parse(root.querySelector('.hiss-wunschmass__variants').textContent);
      const originalDisabled=button.disabled;
      const points={standard:[],premium:[]};
      const finishPosition=Number(root.dataset.finishPosition),materialPosition=Number(root.dataset.materialPosition);
      const surcharge=isBanner?650:0;
      for(const variant of variants){
        if(root.dataset.productHandle==='hissfahnen'&&variant.option2!=='Kunststoff-Karabinerhaken')continue;
        const dimensions=variant.option1.match(/^(\d+) x (\d+) cm$/);
        if(!dimensions)continue;
        const material=variant[`option${materialPosition}`]?.startsWith('Premium')?'premium':'standard';
        points[material].push([Number(dimensions[1]),Number(dimensions[2]),Number(variant.price)-surcharge]);
      }
      if(root.dataset.productHandle==='hissfahnen'){
        points.standard.push([150,400,11000]);
        points.premium.push([150,400,13600]);
      }
      for(const material of ['standard','premium'])points[material].sort((a,b)=>a[0]*a[1]-b[0]*b[1]);
      let quote=null;
      function activeMaterial(){
        const selected=picker.querySelector(`input[data-option-position="${root.dataset.materialPosition}"]:checked`);
        return selected?.nextElementSibling?.textContent.includes('Premium')?'premium':'standard';
      }
      function fixedVariant(){
        const size=picker.querySelector('input[data-option-position="1"]:checked')?.nextElementSibling?.textContent.trim();
        const material=picker.querySelector(`input[data-option-position="${root.dataset.materialPosition}"]:checked`)?.nextElementSibling?.textContent.trim();
        return variants.find(v=>v.option1===size&&v.option2===material);
      }
      function extraCents(w,h){
        const x=extras();
        return (x.ringband?Math.round(h*650/100):0)+(x.weight==='bleiband'?Math.round(w*695/100):x.weight==='holzstab'?695:0)+(x.schlaufe?195:0);
      }
      function anchor(w,h,material){
        const list=points[material],area=w*h,exact=list.find(p=>p[0]===w&&p[1]===h);
        if(exact)return exact[2];
        const index=list.findIndex(p=>p[0]*p[1]>=area);
        if(index===0||index<0){const p=index===0?list[0]:list[list.length-1];return Math.round(area*p[2]/(p[0]*p[1]));}
        const a=list[index-1],b=list[index],aa=a[0]*a[1],ba=b[0]*b[1];
        return Math.round(a[2]+(b[2]-a[2])*(area-aa)/(ba-aa));
      }
      function update(){
        const custom=toggle.checked,selected=custom?null:fixedVariant();
        if(!custom&&!(isBanner&&hasExtras()))return;
        const dimensions=selected?.option1.match(/^(\d+) x (\d+) cm$/);
        const w=custom?Number(root.querySelector('.hiss-wunschmass__width').value):Number(dimensions?.[1]);
        const h=custom?Number(root.querySelector('.hiss-wunschmass__height').value):Number(dimensions?.[2]);
        const pieces=Number(quantity.value),material=activeMaterial();
        quote=null;error.hidden=true;seamNotice.hidden=true;
        if(!Number.isSafeInteger(w)||!Number.isSafeInteger(h)||w<15||h<15||!Number.isSafeInteger(pieces)||pieces<1){
          headline.textContent='–';for(const element of root.querySelectorAll('[data-area],[data-unit],[data-total]'))element.textContent='–';
          error.textContent='Bitte Breite und Höhe ab 15 cm sowie eine gültige Stückzahl eingeben.';error.hidden=false;button.disabled=true;return;
        }
        const rate=material==='premium'?2261:1785;
        const supplement=isBanner?extraCents(w,h):0;
        const exact=points[material].find(point=>point[0]===w&&point[1]===h);
        const base=custom?(exact?Math.max(1500,exact[2]):Math.max(1500,Math.ceil(w*h*rate/10000),anchor(w,h,material))):Number(selected.price);
        const unit=base+(custom?surcharge:0)+supplement;
        const total=unit*pieces;
        if(!Number.isSafeInteger(total)){button.disabled=true;return;}
        const panels=Math.ceil(Math.min(w,h)/300);
        if(custom&&panels>1){
          seamNotice.hidden=false;
          seamNotice.textContent=`Die Rollenbreite beträgt 300,0 cm. Wir nähen ${panels} Teile zusammen, um dieses Wunschmaß zu erreichen.`;
        }
        quote={w,h,pieces,material,unit,total,panels,custom,extras:extras(),supplement};
        headline.textContent=money.format(unit/100);
        if(custom){
          root.querySelector('[data-area]').textContent=areaFormat.format(w*h/10000)+' m²';
          root.querySelector('[data-unit]').textContent=money.format(unit/100);
          root.querySelector('[data-total]').textContent=money.format(total/100);
        }
        if(addonPrice){addonPrice.hidden=!hasExtras();addonPrice.textContent=`Konfektion + ${money.format(supplement/100)} je Fahne · Gesamtpreis ${money.format(total/100)}`;}
        button.disabled=root.dataset.checkoutReady!=='true';
      }
      function mode(){
        const active=toggle.checked;
        const extraActive=isBanner&&hasExtras();
        root.hidden=!active&&!isBanner;
        info.classList.toggle('hiss-wunschmass--active',active);
        info.classList.toggle('banner-konfektion--active',!active&&extraActive);
        picker.classList.toggle('hiss-wunschmass--active',active);
        fields.hidden=!active;headline.hidden=!active&&!extraActive;
        if(addonPrice&&!extraActive)addonPrice.hidden=true;
        picker.querySelector('.hiss-wunschmass__selected-label').hidden=!active;
        if(sticky)sticky.hidden=active||extraActive;
        button.disabled=active||extraActive?true:originalDisabled;
        if(active||extraActive)update();
      }
      toggle.addEventListener('change',event=>{
        event.stopPropagation();remember();mode();
        if(!toggle.checked)picker.querySelector(`input[data-option-position="${root.dataset.materialPosition}"]:checked`)?.dispatchEvent(new Event('change',{bubbles:true}));
      },{signal:controller.signal});
      picker.addEventListener('change',event=>{
        if(event.target.closest('.banner-konfektion')){event.stopImmediatePropagation();syncBannerExtras();remember();mode();}
      },{capture:true,signal:controller.signal});
      picker.addEventListener('change',event=>{
        if(toggle.checked&&event.target.matches(`input[data-option-position="${root.dataset.materialPosition}"],input[data-option-position="${root.dataset.finishPosition}"]`)){
          event.stopImmediatePropagation();remember();update();
        }
      },{capture:true,signal:controller.signal});
      picker.addEventListener('change',event=>{
        if(event.target.matches('input[data-option-position="1"]'))toggle.checked=false;
        remember();
        mode();
      },{signal:controller.signal});
      root.addEventListener('input',()=>{remember();update();},{signal:controller.signal});
      quantity.addEventListener('input',update,{signal:controller.signal});
      quantity.addEventListener('change',update,{signal:controller.signal});
      form.addEventListener('submit',async event=>{
        if(!root.isConnected||picker.querySelector('.hiss-wunschmass')!==root)return;
        if(!toggle.checked&&!(isBanner&&hasExtras()))return;
        event.preventDefault();event.stopImmediatePropagation();update();
        if(!quote||root.dataset.checkoutReady!=='true')return;
        button.disabled=true;
        const finish=finishPosition?picker.querySelector(`input[data-option-position="${finishPosition}"]:checked`)?.nextElementSibling?.textContent.trim():'';
        const materialName=quote.material==='premium'?'Premium, 160 g/m²':'Standard, 110 g/m²';
        const properties={_Wunschbreite:String(quote.w),_Wunschhoehe:String(quote.h),_Tatsaechliche_Stueckzahl:String(quote.pieces),_Material:materialName,_Konfiguration:crypto.randomUUID(),Material:materialName,'Anzahl Fahnen':String(quote.pieces)};
        properties[quote.custom?'Wunschmaß':'Größe']=`${quote.w} × ${quote.h} cm`;
        if(finish){properties._Befestigung=finish;properties[root.dataset.productHandle==='auslegerfahnen'?'Konfektion':'Befestigung']=finish;}
        if(root.dataset.productHandle==='bannerfahne')properties._Befestigung='Holzquerstab mit Kordel';
        if(isBanner){
          if(quote.extras.ringband)properties._Ringbandsicherung='Ja · 6,50 € je lfm Mastseite';
          if(quote.extras.weight!=='keine')properties._Beschwerung=quote.extras.weight==='bleiband'?'Bleiband an der Unterseite · 6,95 € je lfm Fahnenbreite':'Beschwerungsstab aus Holz · 6,95 € je Fahne';
          if(quote.extras.schlaufe)properties._Mittige_Schlaufe='Mit Karabinerhaken · 1,95 € je Fahne';
        }
        if(quote.panels>1)properties.Konfektion=`${quote.panels} Teile zusammengenäht`;
        try{
          const prefix=window.Shopify?.routes?.root||'/';
          const response=await fetch(prefix+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(root.dataset.centVariant),quantity:quote.total,properties}]})});
          if(!response.ok){const body=await response.json().catch(()=>({}));throw new Error(body.description||'Warenkorb konnte nicht aktualisiert werden.');}
          location.assign(prefix+'cart');
        }catch(cause){error.textContent=cause.message;error.hidden=false;button.disabled=false;}
      },{capture:true,signal:controller.signal});
      mode();
    }
    function start(scope=document){scope.querySelectorAll('.hiss-wunschmass').forEach(init);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start());else start();
    document.addEventListener('shopify:section:load',event=>start(event.target));
    new MutationObserver(records=>{
      for(const record of records){
        for(const node of record.addedNodes){
          if(node.nodeType===1&&(node.matches?.('.hiss-wunschmass')||node.querySelector?.('.hiss-wunschmass'))){start(node.matches?.('.hiss-wunschmass')?node.parentElement:node);return;}
        }
      }
    }).observe(document.documentElement,{subtree:true,childList:true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["individuelle-hissfahne-rechner"] && !Shopify.designMode) return;
  try {
    (() => {
    const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    function start(root) {
      const info = root.closest('.product-info');
      const fields = root.querySelector('.hiss-wunschmass__fields');
      const price = root.querySelector('.hiss-wunschmass__price');
      const error = root.querySelector('.hiss-wunschmass__error');
      const submit = root.querySelector('.hiss-wunschmass__submit');
      let quotedCents = null;
      let data;
      try { data = JSON.parse(root.querySelector('.hiss-wunschmass__prices').textContent); }
      catch { error.textContent = 'Preise konnten nicht geladen werden.'; error.hidden = false; return; }
      function quote() {
        const width = Number(root.querySelector('.hiss-wunschmass__width').value);
        const height = Number(root.querySelector('.hiss-wunschmass__height').value);
        const selectedMaterial = root.querySelector('.hiss-wunschmass__material:checked');
        const material = selectedMaterial.dataset.rate;
        root.querySelector('.hiss-wunschmass__material-label').textContent = selectedMaterial.value;
        root.querySelector('.hiss-wunschmass__finish-label').textContent = root.querySelector('input[name="properties[Befestigung]"]:checked').value;
        if (!Number.isInteger(width) || !Number.isInteger(height) || width < 50 || height < 50 || width > 500 || height > 500) {
          quotedCents = null;
          submit.disabled = true;
          price.textContent = '';
          error.textContent = 'Gib pro Seite eine ganze Zahl zwischen 50 und 500 cm ein.';
          error.hidden = false;
          return;
        }
        error.hidden = true;
        const area = width * height / 10000;
        const points = data[material].map(({ size, cents }) => {
          const [w, h] = size.split(' x ').map(value => parseInt(value, 10));
          return { area: w * h / 10000, cents: Number(cents), w, h };
        }).sort((a, b) => a.area - b.area);
        if (!points.length) { price.textContent = 'Preis nicht verfügbar'; return; }
        let cents;
        const exact = points.find(p => p.w === width && p.h === height) || points.find(p => p.area === area);
        if (exact) cents = exact.cents;
        else if (width === 150 && height === 400) cents = data.hochformat150x400[material];
        else if (area < points[0].area) cents = Math.round(points[0].cents * area / points[0].area);
        else if (area > points.at(-1).area) {
          const rate = material === 'premium' ? 2261 : 1785;
          cents = Math.round(points.at(-1).cents + (area - points.at(-1).area) * rate);
        } else {
          const upper = points.findIndex(p => p.area >= area);
          const a = points[upper - 1], b = points[upper];
          cents = Math.round(a.cents + (area - a.area) * (b.cents - a.cents) / (b.area - a.area));
        }
        cents = Math.max(1500, Math.ceil(area * (material === 'premium' ? 2261 : 1785)), cents);
        quotedCents = cents;
        price.textContent = `Preisvorschau: ${fmt.format(cents / 100)} · ${area.toLocaleString('de-DE', { maximumFractionDigits: 2 })} m²`;
        submit.disabled = root.dataset.checkoutReady !== 'true';
      }
      function mode() {
        const custom = root.querySelector('input[value="custom"]').checked;
        root.querySelector('.hiss-wunschmass__mode-label').textContent = custom ? 'Wunschmaß' : 'Standardgröße';
        fields.hidden = !custom;
        const sticky = root.closest('.shopify-section')?.querySelector('.product-quick-add');
        if (sticky) sticky.hidden = custom;
        if (info) {
          for (const selector of ['.product-info__price', '.product-info__variant-picker', '.product-info__quantity-selector', '.product-info__buy-buttons']) {
            const node = info.querySelector(selector);
            if (node) node.hidden = custom;
          }
        }
        if (custom) quote();
      }
      root.addEventListener('input', quote);
      root.addEventListener('change', event => event.target.matches('input[type="radio"]') ? mode() : quote());
      submit.addEventListener('click', async () => {
        quote();
        if (root.dataset.checkoutReady !== 'true' || quotedCents === null) return;
        submit.disabled = true;
        const properties = {};
        root.querySelectorAll('.hiss-wunschmass__fields [name^="properties["]').forEach(field => {
          if (field.type === 'radio' && !field.checked) return;
          properties[field.name.slice(11, -1)] = field.value;
        });
        properties['Anzahl Fahnen'] = '1';
        properties['Preis pro Fahne'] = fmt.format(quotedCents / 100);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(root.dataset.centVariant), quantity: quotedCents, properties }] })
          });
          if (!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
          location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (cause) {
          error.textContent = cause.message;
          error.hidden = false;
          submit.disabled = false;
        }
      });
      mode();
    }
    document.querySelectorAll('.hiss-wunschmass').forEach(start);
  })();
  } catch(e) { console.error(e); }
})();

})();
